import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Messages } from 'src/app/modules/compliance/constants/messages';
import { AddressService } from '../../services/address.service';

@Component({
    selector: 'address',
    templateUrl: './address.component.html'
})
export class AddressComponent implements OnInit {

    public addressFormGroup: UntypedFormGroup;
    
    constructor(
        private _snackBar: MatSnackBar,
        private _formBuilder: UntypedFormBuilder,
        private _addressservice: AddressService) {
        //Form Group Initiation.
        this.fillForm();
    }
    ngOnInit() {
    }
    private fillForm() {
        this.addressFormGroup = this._formBuilder.group(
            {
                addressLine1: ["", Validators.required],
            });
    }
    public addAddress() {
        
    }

    notify() {
        let snackBarRef = this._snackBar.open(Messages.AddressSaved, "Close", {
            duration: 2000,
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }
}